import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import {
  PopoverComboboxContent,
  PopoverComboboxEmpty,
  PopoverComboboxGroup,
  PopoverComboboxInput,
  PopoverComboboxItem,
  PopoverComboboxList,
} from '@/components/ui/custom/PopoverCombobox';
import { Popover, PopoverTrigger } from '@/components/ui/popover';

import { ConditionAttributeConfig, ConditionAttributeGroup } from './constants';

type AttributePickerProps = {
  groups: ConditionAttributeGroup[];
  onSelect: (config: ConditionAttributeConfig) => void;
  children: React.ReactNode;
};

export const AttributePicker = ({ groups, onSelect, children }: AttributePickerProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverComboboxContent
        className="w-60"
        commandProps={{ shouldFilter: true }}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <PopoverComboboxInput />
        <PopoverComboboxList>
          <PopoverComboboxEmpty>{t('common.no_results')}</PopoverComboboxEmpty>
          {groups.map((group) => (
            <PopoverComboboxGroup key={group.labelKey} heading={t(group.labelKey)}>
              {group.attributes.map((config) => (
                <PopoverComboboxItem
                  key={config.value}
                  value={t(config.labelKey)}
                  onSelect={() => {
                    setOpen(false);
                    onSelect(config);
                  }}
                >
                  {t(config.labelKey)}
                </PopoverComboboxItem>
              ))}
            </PopoverComboboxGroup>
          ))}
        </PopoverComboboxList>
      </PopoverComboboxContent>
    </Popover>
  );
};
